import React from 'react';
export function Topbar() {
  return <header className="mx-auto flex max-w-[1100px] justify-center px-6 py-[26px]" data-id="element-146">
      <a href="#" className="inline-flex items-center" aria-label="Cofit — inicio" data-id="element-147">
        <img src="https://cdn.magicpatterns.com/uploads/rbtRbZunH9TdiJSrUdMdoC/logo_mas_oscuro.webp" alt="Cofit" className="h-20 w-auto sm:h-24" data-id="element-148" />
      </a>
    </header>;
}